
export class BadRequestArgsError extends Error {}

export class UnauthorizedError extends Error {}

export class ForbiddenError extends Error {}

export class NotFoundError extends Error {}

export class InternalServerError extends Error {}

export class UserNonexistentError extends Error {}

export class ExpiredTokenError extends Error {}